export const CONNECTION_SET_IS_NATS_CONNECTED = 'connection/is-nats-connected';
export const CONNECTION_SET_IS_INTERNET_CONNECTED = 'connection/is-internet-connected';
export const CONNECTION_COPY_CONNECTION_STATE = 'connection/copy-connection-state';